import { Component, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
})
export class CustomTooltipComponent implements OnInit {
  tooltip: TemplateRef<any> | null;
  left: number = 0;
  top: number = 0;

  constructor() {
    this.tooltip = null;
  }

  ngOnInit(): void {}
}
